import { GetterTree, Module } from "vuex";
import { RootState } from "../store";

import PackageDesktopConfig from "./types/package-app.config-class";
import { IDesktopStore } from "./types/package-app.types";

const state: IDesktopStore = {
  config: new PackageDesktopConfig()
};

const getters: GetterTree<IDesktopStore, RootState> = {
  config: (state: IDesktopStore) => state.config
};

export const packageStore: Module<IDesktopStore, RootState> = {
  namespaced: true,
  getters,
  state
};
